import { useState } from 'react';
import { Chart } from '@evogard/ui/chart';
import { format as formatMoney, sum, type Money } from '@evogard/domain';
import type { FinanceDashboardRowWire } from '@evogard/contract';
import { compact } from './money.js';
import { MeasureToggle, valueOf, type Measure } from './MeasureToggle.js';

/**
 * Um corte do painel como a parte de um todo — a pizza, ou a rosca com o
 * total no miolo (29/10/2026, para a direção). A chave do cabeçalho troca a
 * receita pela despesa; o saldo não entra porque não existe fatia negativa.
 *
 * Cinco fatias no máximo: as menores somam num "Outros" cinza, e a tabela do
 * "Ver tabela" mostra cada linha com a participação dela.
 */
export function ShareChart({
  title,
  descricao,
  rows,
  loading,
  error,
  donut = false,
}: {
  title: string;
  descricao: string;
  rows: readonly FinanceDashboardRowWire[] | undefined;
  loading: boolean;
  error: Error | null;
  donut?: boolean;
}) {
  const [measure, setMeasure] = useState<Measure>('receitas');
  const list = rows ?? [];
  const total = sum(...list.map((r) => valueOf(r, measure)));

  return (
    <Chart
      kind="pizza"
      title={title}
      descricao={descricao}
      label={`${measure === 'receitas' ? 'Receita' : 'Despesa'} ${title.toLowerCase()}`}
      data={list}
      loading={loading && list.length === 0}
      error={error}
      empty="Nenhum lançamento no período."
      actions={list.length > 0 && <MeasureToggle value={measure} onChange={setMeasure} />}
      maxSlices={5}
      format={(v) => formatMoney(v as Money)}
      slice={{ label: (r) => r.label, value: (r) => valueOf(r, measure) }}
      center={
        donut ? (
          <>
            <span className="block text-lg font-semibold text-texto tabular-nums">
              {compact(total)}
            </span>
            <span className="text-xs text-texto-suave">
              {measure === 'receitas' ? 'de receita' : 'de despesa'}
            </span>
          </>
        ) : undefined
      }
    />
  );
}
